























import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  name: "TooltipSimple"
})

export default class TooltipSimple extends Vue {
  @Prop({ type: Boolean, default: false}) protected disabled: any
  @Prop({ type: String, default: ''}) protected text: any
  @Prop({ type: String, default: ''}) protected tooltip: any
  @Prop({ type: [Number, String], default: 100}) protected delay: any
  @Prop({type: Boolean, default: false}) protected top!: boolean
  @Prop({type: Boolean, default: false}) protected left!: boolean
  @Prop({type: Boolean, default: false}) protected bottom!: boolean
  @Prop({type: Boolean, default: false}) protected right!: boolean
  @Prop({type: String, default: 'div'}) protected tag!: string
}
